import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// Calendar header matching CustomDateRangePicker: bordered chevron nav buttons
// and a centered clickable title that drills day -> month -> year -> day.
// Used by CustomDatePicker and installed app-wide as the MUI X calendarHeader
// slot default in src/theme/theme.ts (no theme import here — that would be a
// circular dependency).
const FigmaCalendarHeader: React.FC<any> = ({
  currentMonth,
  onMonthChange,
  view,
  views,
  onViewChange,
}) => {
  const navBtnSx = {
    width: 28,
    height: 28,
    border: "1px solid",
    borderColor: (t: any) => (t.palette.mode === "dark" ? "#2E2E38" : "#e3e6ea"),
    borderRadius: "6px",
    color: "text.secondary",
  } as const;
  // Drill day -> month -> year -> day, skipping views the picker doesn't offer.
  const has = (v: string) => !views || views.includes(v);
  const nextView =
    view === "day"
      ? has("month") ? "month" : has("year") ? "year" : "day"
      : view === "month"
      ? has("year") ? "year" : "day"
      : "day";
  // Day view pages by month, month view pages by year; the year grid manages
  // its own scroll position, so it gets no chevrons.
  const step = view === "day" ? { unit: "month" as const } : view === "month" ? { unit: "year" as const } : null;
  const title = view === "day" ? currentMonth.format("MMM YYYY") : currentMonth.format("YYYY");
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 1.5,
        pt: 1.5,
        pb: 0.5,
      }}
    >
      {step ? (
        <IconButton
          size="small"
          sx={navBtnSx}
          onClick={() => onMonthChange(currentMonth.subtract(1, step.unit), "right")}
        >
          <ChevronLeftIcon sx={{ fontSize: 18 }} />
        </IconButton>
      ) : (
        <Box sx={{ width: 28 }} />
      )}
      <Typography
        onClick={() => onViewChange?.(nextView)}
        sx={{
          fontSize: 14,
          fontWeight: 600,
          color: "text.primary",
          cursor: "pointer",
          userSelect: "none",
          "&:hover": { color: "#3C7795" },
        }}
      >
        {title}
      </Typography>
      {step ? (
        <IconButton
          size="small"
          sx={navBtnSx}
          onClick={() => onMonthChange(currentMonth.add(1, step.unit), "left")}
        >
          <ChevronRightIcon sx={{ fontSize: 18 }} />
        </IconButton>
      ) : (
        <Box sx={{ width: 28 }} />
      )}
    </Box>
  );
};

export default FigmaCalendarHeader;
